module.exports = __webpack_public_path__ + "static/img/p5-1-1.5db50df.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about/p5-1-1.png
// module id = anXx
// module chunks = 1